import { EmbeddedMessage, MessageMedium, WhatsApp } from 'constants/messageMediums';
import { CampaignStep } from '../types';
import {
  AudienceEligibilitySection,
  AudienceSection,
  AudienceTriggeredSection,
  BehaviorSection,
  ContentSection,
  ConversionSection,
  CustomTextFieldsSection,
  DisplaySection,
  EmbeddedDeliverySection,
  InAppOptionsSection,
  LinksSection,
  OptimizeSection,
  SchedulingSection,
  SendingInformationSection,
  TypeSection,
} from './Sections';

// extract and use with all of our mappers
export type EnumMapper<T extends string, V> = {
  [key in T]?: V;
};

type SummaryMapper = EnumMapper<MessageMedium, (() => JSX.Element)[]>;

export const BLAST_SECTION_MAPPER: EnumMapper<CampaignStep, () => JSX.Element> = {
  [CampaignStep.Audience]: AudienceSection,
  [CampaignStep.ConversionAndExperiment]: ConversionSection,
  [CampaignStep.Delivery]: OptimizeSection,
};

export const TRIGGERED_SECTION_MAPPER: EnumMapper<CampaignStep, () => JSX.Element> = {
  [CampaignStep.AudienceTriggered]: AudienceTriggeredSection,
  [CampaignStep.ConversionAndExperiment]: ConversionSection,
  [CampaignStep.Delivery]: OptimizeSection,
};

export const ELIGIBILITY_SECTION_MAPPER: EnumMapper<CampaignStep, () => JSX.Element> = {
  [CampaignStep.AudienceEligibility]: AudienceEligibilitySection,
  [CampaignStep.Display]: DisplaySection,
  [CampaignStep.Delivery]: EmbeddedDeliverySection,
};

export const ELIGIBILITY_TRIGGERED_SECTION_MAPPER: EnumMapper<CampaignStep, () => JSX.Element> = {
  [CampaignStep.AudienceTriggered]: AudienceTriggeredSection,
  [CampaignStep.Display]: DisplaySection,
  [CampaignStep.Delivery]: EmbeddedDeliverySection,
};

export const WHATSAPP_BLAST_SECTION_MAPPER: EnumMapper<CampaignStep, () => JSX.Element> = {
  [CampaignStep.Audience]: AudienceSection,
  [CampaignStep.Conversions]: ConversionSection,
};

export const WHATSAPP_TRIGGERED_SECTION_MAPPER: EnumMapper<CampaignStep, () => JSX.Element> = {
  [CampaignStep.AudienceTriggered]: AudienceTriggeredSection,
  [CampaignStep.Conversions]: ConversionSection,
};

export const BLAST_SUMMARY_SECTION_MAPPER: SummaryMapper = {
  [MessageMedium.Email]: [
    SchedulingSection,
    TypeSection,
    AudienceSection,
    SendingInformationSection,
    ConversionSection,
    OptimizeSection,
    ContentSection,
    LinksSection,
  ],
  [MessageMedium.InApp]: [
    SchedulingSection,
    TypeSection,
    InAppOptionsSection,
    AudienceSection,
    SendingInformationSection,
    ConversionSection,
    OptimizeSection,
    ContentSection,
    BehaviorSection,
  ],
  [MessageMedium.Push]: [
    SchedulingSection,
    TypeSection,
    AudienceSection,
    SendingInformationSection,
    ConversionSection,
    OptimizeSection,
    ContentSection,
    BehaviorSection,
  ],
  [MessageMedium.SMS]: [
    SchedulingSection,
    TypeSection,
    AudienceSection,
    SendingInformationSection,
    ConversionSection,
    OptimizeSection,
    ContentSection,
    LinksSection,
  ],
  [MessageMedium.WebPush]: [
    SchedulingSection,
    TypeSection,
    AudienceSection,
    SendingInformationSection,
    ConversionSection,
    OptimizeSection,
    ContentSection,
    BehaviorSection,
  ],
  [WhatsApp]: [
    TypeSection,
    AudienceSection,
    SendingInformationSection,
    ConversionSection,
    ContentSection,
  ],
};

export const TRIGGERED_SUMMARY_SECTION_MAPPER: SummaryMapper = {
  [MessageMedium.Email]: [
    TypeSection,
    SendingInformationSection,
    ConversionSection,
    OptimizeSection,
    ContentSection,
    LinksSection,
  ],
  [MessageMedium.InApp]: [
    TypeSection,
    InAppOptionsSection,
    SendingInformationSection,
    ConversionSection,
    OptimizeSection,
    ContentSection,
    BehaviorSection,
  ],
  [MessageMedium.Push]: [
    TypeSection,
    SendingInformationSection,
    ConversionSection,
    OptimizeSection,
    ContentSection,
    BehaviorSection,
  ],
  [MessageMedium.SMS]: [
    TypeSection,
    SendingInformationSection,
    ConversionSection,
    OptimizeSection,
    ContentSection,
    LinksSection,
  ],
  [MessageMedium.WebPush]: [
    TypeSection,
    SendingInformationSection,
    ConversionSection,
    OptimizeSection,
    ContentSection,
    BehaviorSection,
  ],
  [EmbeddedMessage]: [
    TypeSection,
    DisplaySection,
    EmbeddedDeliverySection,
    ConversionSection,
    ContentSection,
    CustomTextFieldsSection,
    BehaviorSection,
  ],
  [WhatsApp]: [TypeSection, SendingInformationSection, ConversionSection, ContentSection],
};

export const ELIGIBILITY_SUMMARY_SECTION_MAPPER: SummaryMapper = {
  [EmbeddedMessage]: [
    SchedulingSection,
    TypeSection,
    AudienceEligibilitySection,
    DisplaySection,
    EmbeddedDeliverySection,
    ConversionSection,
    ContentSection,
    CustomTextFieldsSection,
    BehaviorSection,
  ],
};
